<template>
  <div class="pay-view">
    <p class="p-text">付款金额：<span class="payAmount">{{ payObj.payAmount }}</span>元</p>
    <p class="p-text1">付款方式：</p>
    <div class="radio-view">
      <el-radio v-model="radio" label="1" border>支付宝</el-radio>
    </div>
    <br>
    <br>
    <el-button type="primary" @click="pay">下一步</el-button>
    <form name="form1" id="form1" method="post" :action="form_action" style="display:none">
      <input type="text" name="payAmount" v-model="payObj.payAmount">
      <input type="text" name="orderNo" v-model="payObj.orderNo">
      <input type="text" name="subject" v-model="payObj.subject">
      <input type="text" name="body" v-model="payObj.body">
      <input type="submit" @click="pay">
    </form>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      radio: '1',
      money: 0,
      payObj: {
        payAmount: 0,
        orderNo: '',
        subject: '',
        body: ''
      },
      form_action: this.$allUrl.pay
    }
  },
  methods: {
    pay () {
      document.getElementById('form1').submit()
    }
  },
  mounted () {
    let query = this.$route.query
    if (query) {
      this.payObj = query
    }
  }
}
</script>
<style lang="less" scoped>
  .pay-view{
    height: 500px;
    width: 100%;
    padding: 0 10px;
    .p-text{
      padding-top: 50px;
    }
    .payAmount{
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pay/pay.vue


// WEBPACK FOOTER //
// src/components/pay/pay.vue